import React from 'react'
import ReactDOM from 'react-dom'
import { ThemeProvider } from 'react-jss'
import App from 'mttr/App'
import theme from 'common/theme'
import { addLocaleData, IntlProvider } from 'react-intl'
import messages from 'mttr/messages'
import en from 'react-intl/locale-data/en'
import pl from 'react-intl/locale-data/pl';

addLocaleData([...en, ...pl])

const node = document.getElementById('mttr')
const { locale } = node.dataset

ReactDOM.render(
  <IntlProvider locale={locale} messages={messages[locale]}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </IntlProvider>,
  node
)
